import Vue from 'vue'
import ActionBar from './pageActions/ActionBar'
import vSelect from 'vue-select'
import VueUploadComponent from 'vue-upload-component'
import Scans from './scans/ScansGallery'
import ScanCard from './scans/Card'
import LightBox from './LightBox'
import Document from './Document'
import Events from './Events'
import Logout from './Logout'
import VueResizable from 'vue-resizable'
import Mselect from './Mselect'
import Multiselect from 'vue-multiselect'
import TableSort from './TableSort'

Vue.component('multiselect', Multiselect)
Vue.component('Mselect', Mselect)
Vue.component('VueResizable', VueResizable)
Vue.component('Logout', Logout)
Vue.component('file-upload', VueUploadComponent)
Vue.component('v-select', vSelect)
Vue.component('ActionBar', ActionBar)
Vue.component('Scans', Scans)
Vue.component('ScanCard', ScanCard)
Vue.component('LightBox', LightBox)
Vue.component('Document', Document)
Vue.component('Events', Events)
Vue.component('TableSort', TableSort)
